import React, { createContext, useState } from "react";

// Criação do contexto
export const GlobalStateContext = createContext();

// Provedor do contexto
export const GlobalStateProvider = ({ children }) => {
  const [clickedItem, setClickedItem] = useState(null);

  // Função para atualizar o estado com o item clicado
  const handleItemClick = (item) => {
    setClickedItem(item);
    console.log(`Item clicado: ${item}`);
  };

  return (
    <GlobalStateContext.Provider value={{ clickedItem, handleItemClick }}>
      {children}
    </GlobalStateContext.Provider>
  );
};
